// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1O4HJ","inner":"Form_inner__2e85A","range":"Form_range__1vYQu","name":"Form_name__2BOLx","actions":"Form_actions__1zG0C"};